import { Pulse } from "../Pulse";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

interface TableSkeletonProps {
  numRows: number;
  columnsLength: number;
}

export const TableSkeleton = ({ numRows, columnsLength }: TableSkeletonProps) =>
  Array.from({ length: numRows }, (_, index) => (
    <TableRow key={index}>
      {Array.from({ length: columnsLength }, (_, idx) => (
        <TableCell key={idx}>
          <Pulse className="w-1/2" />
        </TableCell>
      ))}
    </TableRow>
  ));
